import trackEvent from 'utils/analytics';
import { Box, Button, ChevronDownIcon, ChevronUpIcon } from 'v1/ui';

type Props = {
  groupId: string;
  ruleTitle: string;
  showMore: boolean;
  setShowMore: (arg0: boolean) => void;
};
export default function ShowMore({
  groupId,
  ruleTitle,
  showMore,
  setShowMore,
}: Props) {
  return (
    <Button
      variant="link"
      onClick={() => {
        setShowMore(!showMore);
        trackEvent.reviewMessageShowMore({ groupId, ruleTitle });
      }}
      sx={{
        color: showMore ? 'rgba(114, 118, 127, 1)' : 'blue',
        fontSize: 15,
        alignItems: 'center',
        ml: '-10px',
        p: 2,
        mt: showMore ? 4 : -2,
      }}
    >
      <Box sx={{ pb: 1, pl: 1 }}>{showMore ? 'Show less' : 'Show more'}</Box>
      {showMore ? (
        <ChevronUpIcon color="rgba(114, 118, 127, 1)" size={30} />
      ) : (
        <ChevronDownIcon color="blue80" size={30} />
      )}
    </Button>
  );
}
